<template>
  <v-card outlined>
    <v-card-title>
      Информация по рейтингу
    </v-card-title>
    <v-card-text>
      <v-data-table
        dense
        :headers="headers"
        :items="items"
        :loading="loading"
        item-key="id"
        @click:row="toUserList"
        hide-default-footer
      >
        <template v-slot:item.status="{ item }">
          <div class="flex">
            <v-icon
              class="mr-3"
              v-bind="attrs"
              v-on="on"
              :color="getStatusColor(item.status)"
            >
              {{ getStatusIcon(item.status) }}
            </v-icon>

            <span> {{ getStatusName(item.status) }} </span>
          </div>
        </template>
        <template v-slot:item.sum="{ item }">
          {{ rub.format(item.sum) }}
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>
<script>
import { getRatingSumInfo } from "../../services/rating.service";
import { USERS_ROUTE } from "@/router/names";
import {
  getStatusName,
  getStatusColor,
  getStatusIcon
} from "../../constants/status.constants";

export default {
  name: "RatingSumInfo",

  props: {
    rating: { type: Object, required: true }
  },

  components: {},

  computed: {},

  data() {
    return {
      headers: [
        { text: "Состояние заявки", value: "status" },
        { text: "Количество заявок", value: "count" },
        { text: "Сумма", value: "sum" }
      ],
      items: [],
      rub: Intl.NumberFormat("ru-RU", {
        style: "currency",
        currency: "RUB",
        currencyDisplay: "symbol"
      })
    };
  },

  watch: {
    rating: {
      handler(v) {
        this.load();
      },
      immediate: true
    }
  },

  methods: {
    getStatusName,
    getStatusColor,
    getStatusIcon,
    async toUserList(item) {
      await this.$router.push({
        name: USERS_ROUTE,
        query: { ratingRequestStatus: item.status }
      });
    },
    async load() {
      if (this.rating.id) {
        try {
          this.loading = true;
          this.items = await getRatingSumInfo(this.rating.id);
        } catch (e) {
          this.$notify({
            text: e.response ? e.response.data.message : e,
            type: "error"
          });
        } finally {
          this.loading = false;
        }
      } else {
        this.items = [];
      }
    }
  }
};
</script>
